export default __webpack_public_path__ + "static/media/share-pink-14px.b67b790e.svg";